import projectPreview from "@/assets/images/projects/SalesRepConnect.png";
import gemsByWPreview from "@/assets/images/projects/GemsByW.png";
import dkellSystemsPreview from "@/assets/images/projects/DKellSystems.png";

export const projects = [
  {
    title: "D-Kell Systems",
    description:
      "A web development and business technology venture intended to help small businesses in South Africa and internationally establish an online presence and improve their day-to-day operations through websites, online stores, and custom business systems.",
    stack: ["Nuxt", "Vue", "Firebase Hosting"],
    category: "Business Technology",
    year: "2026",
    highlights: [
      "The website introduces the services, showcases work, and gives prospective clients a clear route to discuss a project.",
      "Intended services include administration platforms, workflow automation, booking systems, and business dashboards alongside websites and online stores.",
      "Projects are scoped around each business's requirements, from an initial discussion and quote through design, development, testing, and handover.",
      "Ongoing maintenance, support, and further development are available by agreement as a business grows.",
    ],
    image: dkellSystemsPreview,
    imageFit: "contain",
    live: "https://dkellsystems.web.app/",
    github: "",
  },
  {
    title: "SalesRepConnect",
    description:
      "A SaaS platform built for sales teams to create digital business cards, manage agents, capture leads, track QR scans, and monitor performance through a centralized dashboard.",
    stack: [
      "Vue 3",
      "TypeScript",
      "Pinia",
      "Vue Router",
      "Firebase Authentication",
      "Cloud Firestore",
      "Tailwind CSS",
      "Chart.js",
      "Vite",
      "Firebase Hosting",
    ],
    category: "SaaS Platform",
    year: "2026",
    highlights: [
      "Built a full layered architecture with Vue components, Pinia stores, domain services, and Firebase infrastructure.",
      "Implemented authentication, registration workflows, team management, role-based access control, and company-level multi-tenant data structure.",
      "Created digital business cards with QR generation, scan tracking, public lead capture, and internal CRM dashboards for agents, leads, and analytics.",
      "Designed the platform to help companies manage sales representatives, share professional digital contact experiences, and convert engagement into trackable leads.",
    ],
    image: projectPreview,
    live: "https://salesrepconnect.web.app/",
    github: "",
  },
  {
    title: "GemsByW Website",
    description:
      "An e-commerce website for a jewelry brand, showcasing products, collections, and providing a seamless shopping experience."  ,
    stack: [
      "Vue 3",
      "TypeScript",
      "Pinia",
      "Vue Router",
      "Tailwind CSS",
      "Vite",
    ],
    category: "E-commerce Website",
    year: "2026",
    highlights: [
      "Designed and implemented a responsive layout using modern CSS frameworks.",
      "Integrated product catalog and shopping cart functionality.",
      "Implemented user authentication and order management features.",
      "Optimized website performance and SEO for better visibility.",
    ],
    image: gemsByWPreview,
    live: "https://gemsbyw.web.app/",
    github: "https://github.com/daanyaalkellerman/gemsbyw-catalogue",
  }
];

export const experience = [
  {
    period: "July 2025 - July 2026",
    role: "FutureRent - Intermediate Developer",
    description:
      "Worked in a team of five developers delivering and maintaining production web and mobile applications, including FutureRent, Ace Radio, and AutoCars.",
    highlights: [
      "Developed and maintained the client-facing FutureRent mobile application.",
      "Integrated third-party APIs to extend platform functionality and automate business processes.",
      "Helped gather requirements, scope solutions, and implement business requirements across departments.",
      "Created WATI templates and lead capture forms to automate customer engagement and improve lead management.",
    ],
    stack: ["React", "Expo", "TypeScript", "Tailwind CSS", "API Integration", "Docker", "PHP", "Git"],
  },
  {
    period: "July 2024 - July 2025",
    role: "FutureRent - Junior Developer",
    description:
      "Developed and maintained an internal web application to streamline business processes and improve operational efficiency.",
    highlights: [
      "Built reporting tools and dashboards to provide operational insights and support business decisions.",
      "Integrated the Xero Invoice API to automate invoice generation and streamline invoicing.",
      "Contributed to Agile sprint planning, daily stand-ups, and collaborative delivery.",
      "Participated in code reviews and quality assurance to maintain coding standards and application reliability.",
    ],
    stack: ["PHP", "Vue.js", "JavaScript", "Node.js", "Docker", "API Integration", "Git"],
  },
  {
    period: "March 2024 - July 2024",
    role: "Life Choices Studio - Web Developer Intern",
    description:
      "Developed responsive web applications with HTML, CSS, and JavaScript for desktop and mobile devices.",
    highlights: [
      "Designed and implemented user interfaces, incorporating feedback to improve usability.",
      "Troubleshot frontend issues to improve application performance and user experience.",
      "Participated in code reviews and applied best practices to improve code quality.",
    ],
    stack: ["HTML", "CSS", "JavaScript", "Vue.js", "Node.js", "WordPress", "SEO"],
  },
  {
    period: "September 2023 - July 2024",
    role: "Life Choices Coding Academy",
    description:
      "Completed full-stack development training and earned a Certificate of Excellence - Full Stack Developer.",
  },
];

export const skills = [
  {
    category: "Frontend",
    summary:
      "Interfaces built for clarity, responsiveness, and maintainable product growth.",
    items: ["React", "Next.js", "Vue", "Tailwind", "JavaScript", "TypeScript"],
  },
  {
    category: "Backend",
    summary:
      "Application logic and integrations structured around business workflows and clean data flow.",
    items: ["Node.js", "Express", "Knex", "PHP"],
  },
  {
    category: "Data",
    summary:
      "Relational and document data modeling for products that need dependable querying and reporting.",
    items: ["MySQL", "PostgreSQL", "MariaDB", "MongoDB"],
  },
  {
    category: "Mobile",
    summary:
      "Cross-platform product delivery when the same experience needs to extend cleanly to handheld devices.",
    items: ["React Native", "Expo"],
  },
];

export const socialLinks = [
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/daanyaal-kellerman-1aba78300",
    icon: "linkedin",
  },
  {
    label: "GitHub",
    href: "https://github.com/daanyaalkellerman",
    icon: "github",
  },
];

export const contactDetails = [
  {
    label: "Preferred Contact",
    value: "LinkedIn direct message",
    href: "https://www.linkedin.com/in/daanyaal-kellerman-1aba78300",
  },
  {
    label: "Location",
    value: "Cape Town, South Africa",
    href: "",
  },
  {
    label: "Focus",
    value: "Product, platform, internal tooling",
    href: "",
  },
];

export const studyProfiles = [
  {
    label: "HackTheBox Academy",
    value: "Cyber Security Fundamentals",
    href: "https://profile.hackthebox.com/profile/019eeafe-64e8-7150-a740-b0f2036df4ad?utm_medium=copy_url",
  },
  {
    label: "TryHackMe",
    value: "Cyber Security Fundamentals",
    href: "https://tryhackme.com/p/kildama?utm_campaign=social_share&utm_medium=social&utm_content=profile&cardVersion=e2fede1d5a4f&utm_source=copy&sharerId=6964acc30967ae18b729b65b"
  }
]
